// extracted by mini-css-extract-plugin
export default {"document":"DocumentNode_document__lBRXI","text":"DocumentNode_text__w7jMO"};